export default __webpack_public_path__ + "static/media/icon-nicht-fakturiert.d44f2b8a.svg";